export default __webpack_public_path__ + "static/media/pflastern-4.7897f065.jpeg";